// Shared constants + helpers for the Crew HR / profile system.

export const CERT_TYPES = [
  { key: "stcw", label: "STCW" },
  { key: "eng1", label: "ENG1 / Medical" },
  { key: "seafarer_book", label: "Seafarer book" },
  { key: "captain_license", label: "Captain license" },
  { key: "engineer_license", label: "Engineer license" },
  { key: "food_hygiene", label: "Food hygiene" },
  { key: "powerboat", label: "Powerboat license" },
  { key: "visa", label: "Visa / work permit" },
  { key: "other", label: "Other" },
];

export const SKILLS = [
  "navigation", "engine_maintenance", "electrical", "tender_driving",
  "watersports", "cooking", "silver_service", "housekeeping", "detailing",
  "teak_work", "diving", "fishing", "security", "first_aid",
];

export const AVAILABLE_FOR = [
  { key: "full_time", label: "Full-time" },
  { key: "part_time", label: "Part-time" },
  { key: "day_work", label: "Day work" },
  { key: "delivery", label: "Delivery" },
  { key: "seasonal", label: "Seasonal" },
];

export const DOC_KINDS = [
  { key: "passport", label: "Passport" },
  { key: "other_id", label: "Other ID" },
  { key: "contract", label: "Employment Contract" },
  { key: "nda", label: "NDA" },
  { key: "insurance", label: "Insurance" },
  { key: "health_insurance", label: "Health Insurance" },
  { key: "company_form", label: "Company form" },
  { key: "onboarding", label: "Onboarding checklist" },
  { key: "handover", label: "Handover checklist" },
  { key: "training", label: "Training record" },
  { key: "other", label: "Other" },
];

export const CONTRACT_TYPES = [
  { key: "full_time", label: "Full-time" },
  { key: "part_time", label: "Part-time" },
  { key: "weekly", label: "Weekly" },
  { key: "daily", label: "Daily" },
  { key: "hourly", label: "Hourly" },
];

export const SALARY_PERIODS = [
  { key: "monthly", label: "per month" },
  { key: "weekly", label: "per week" },
  { key: "daily", label: "per day" },
  { key: "hourly", label: "per hour" },
];

export const PAYMENT_METHODS = [
  { key: "cash", label: "Cash" },
  { key: "bank_transfer", label: "Bank transfer" },
];

export const PAY_TYPES = [
  { key: "hourly", label: "Hourly" },
  { key: "daywork", label: "Daily" },
  { key: "weekly", label: "Weekly" },
  { key: "salary", label: "Monthly" },
  { key: "leave", label: "Leave" },
  { key: "advance", label: "Advance" },
  { key: "loan", label: "Loan" },
  { key: "bonus", label: "Bonus" },
];

// Hourly / Daily / Weekly entries capture a quantity (× hours/days/weeks);
// Monthly / Advance / Bonus / Leave capture a Month/Year period instead.
export const PAY_QTY_TYPES = ["daywork", "hourly", "weekly"];
export const PAY_UNITS = ["hours", "days", "weeks"];
export const payUnitFor = (type) =>
  (type === "hourly" ? "hours" : type === "weekly" ? "weeks" : "days");
export const paymentMethodLabel = (key) =>
  ({ cash: "Cash", bank_transfer: "Bank transfer" }[key] || "");
export const payTypeLabel = (key) =>
  (PAY_TYPES.find((t) => t.key === key) || {}).label || titleCase(key);

export const REHIRE = [
  { key: "yes", label: "Yes" },
  { key: "maybe", label: "Maybe" },
  { key: "no", label: "No" },
];

export const titleCase = (s) =>
  (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// Tiered status for a certificate / passport expiry date (mirrors backend).
export function certStatus(expiry) {
  if (!expiry) return { days: null, status: "unknown" };
  const exp = new Date(`${String(expiry).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(exp.getTime())) return { days: null, status: "unknown" };
  const days = Math.floor((exp - new Date(new Date().toDateString())) / 86400000);
  let status = "ok";
  if (days < 0) status = "expired";
  else if (days <= 30) status = "critical";
  else if (days <= 60) status = "warning";
  else if (days <= 90) status = "notice";
  return { days, status };
}

export const STATUS_STYLE = {
  expired: "bg-red-100 text-red-700 border-red-200",
  critical: "bg-red-50 text-red-600 border-red-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  notice: "bg-yellow-50 text-yellow-700 border-yellow-200",
  ok: "bg-emerald-50 text-emerald-700 border-emerald-200",
  unknown: "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export function statusLabel(status, days) {
  if (status === "expired") return `Expired ${Math.abs(days)}d ago`;
  if (days == null) return "No expiry";
  if (status === "ok") return `Valid · ${days}d`;
  return `Expires in ${days}d`;
}
